/*
 * The gate. Nothing behind it is fetched until GitHub has said who you are,
 * and GitHub decides what you then see. This screen makes no access decisions
 * of its own.
 */
import { GitBranch, GitHub, Shield, Warning } from './Icons'
import { loginUrl } from '../lib/api'

export function SignIn({ org, configured, error }: { org: string; configured: boolean; error?: string | null }) {
  return (
    <div className="gate">
      <div className="gate-card">
        <span className="brand-mark"><GitBranch size={26} /></span>
        <h1>Repository state, live</h1>
        <p>
          Branches, the promotion pipeline, open pull requests and CI for any repository in the{' '}
          <strong style={{ color: 'var(--color-text)', fontWeight: 500 }}>{org}</strong> organization.
        </p>

        <ul className="gate-list">
          <li><span className="ic"><Shield size={15} /></span><span>You see exactly the repositories your GitHub account can already see. Nothing more.</span></li>
          <li><span className="ic"><Shield size={15} /></span><span>Read-only. The app never writes to a repository.</span></li>
          <li><span className="ic"><Shield size={15} /></span><span>Your GitHub token stays in an encrypted server-set cookie, never in browser storage.</span></li>
        </ul>

        {error ? (
          <div className="banner" style={{ marginTop: 22, marginBottom: 0 }}>
            <Warning size={16} />
            <span className="body">{error}</span>
          </div>
        ) : null}

        {configured ? (
          <a className="btn" href={loginUrl()}><GitHub size={17} /> Sign in with GitHub</a>
        ) : (
          <div className="banner" style={{ marginTop: 22, marginBottom: 0 }}>
            <Warning size={16} />
            <span className="body">
              <strong>Not configured.</strong> This deployment is missing its GitHub credentials. Set{' '}
              <code>GITHUB_CLIENT_ID</code>, <code>GITHUB_CLIENT_SECRET</code> and <code>SESSION_SECRET</code> in the
              Static Web App configuration. See <code>DEPLOYMENT.md</code>.
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
